// extracted by mini-css-extract-plugin
module.exports = {"caption":"MinimalHero-module--caption--2FsGG"};